import React from "react";
import Header from "./Header";

const LandingPage = props => {
	const arrow = {
		maxWidth: "2rem",
		maxHeight: "6.5rem"
	};

	function handleClick() {
		props.handlePageChange(1);
	}

	return (
		<div className="wrapper">
			<Header />
			<div style={props.contentStyle}>
				<div className="mainTitle landingMainTitle">
					Kiek kainuoja sukurti mobilią programėlę?
				</div>
				<div className="secondaryTitle">
					Nemokama app kūrimo kainos skaičiuoklė
				</div>
				<div onClick={handleClick} className="button calculateButton">
					Skaičiuoti
				</div>
				<a className="alternativeTitle" href="#secPage">
					<div className="landingArrowDown">
						O gal norite populiariaus projekto analogo kainos?
					</div>
					<img
						alt="greenArrow"
						className="greenArrow"
						style={arrow}
						src={"/skaiciuokle/img/greenArrow.png"}
					/>
				</a>
			</div>
		</div>
	);
};

export default LandingPage;
